module.exports = __webpack_public_path__ + "media/images/info_icon-1b5cf787.png";